export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.pauseIcon)+' '+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14"> <path fill="#FFF" fill-rule="evenodd" d="M7 0h3v14H7V0zM0 0h3v14H0V0z"/> </svg></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/interaction-indicator/templates/pauseIcon.dot
// module id = 141
// module chunks = 0 1 2 3 4